import { FormattedMessage } from 'react-intl'

import type { Step, StepType } from 'containers/Flow/Step'

import { HeaderIconWaiting } from 'components/Icons'
import { Card } from 'components/Layout'

import { IconContainer } from '../IconContainer'
import { Wrapper } from '../Wrapper'

type Props = TaggedType<Step, StepType.MissingCoapplicant>

export const MissingCoapplicant = ({ userMetadata: { coapplicantName } }: Props) => (
	<Wrapper>
		<Card>
			<IconContainer>
				<h1>
					<FormattedMessage id='flow.missingCoapplicant.title' defaultMessage='Waiting for co-applicant' />
				</h1>
				<HeaderIconWaiting />
				<div>
					<p>
						<FormattedMessage
							id='flow.missingCoapplicant.description'
							defaultMessage='Before you can finalize the budget, {coapplicantName} must first submit its information.'
							values={{ coapplicantName }}
						/>
					</p>
					<p>
						<FormattedMessage
							id='flow.missingCoapplicant.description2'
							defaultMessage='Once this is done, reopen the link and log in again with the password provided, and you can finalize the budget together.'
						/>
					</p>
				</div>
			</IconContainer>
		</Card>
	</Wrapper>
)
